<template>
  <v-sheet
      class="mx-auto mt-10 pa-4 text-center py-10"
      max-width="600"
      rounded elevation="1"
  >
    <v-icon size="50" class="mb-2" color="warning">mdi-alert</v-icon>
    <div class="title">Доступ запрещен</div>
    <div>Обратитесь к администратору или в тех.поддержку</div>
  </v-sheet>
</template>

<script>
export default {
  mounted() {
  }
}
</script>
